module.exports = __webpack_public_path__ + "static/media/sun.9827624d.svg";